import currency from 'currency.js';
import _ from 'lodash';

export const currencies = [
    // {key: 'USD', symbol: '$'},
    {key: 'MXN', symbol: '$'},
    {key: 'EUR', symbol: '€'},
    {key: 'VND', symbol: '₫'},

    // {key: 'KZT', symbol: '₸'},
    // {key: 'RUB', symbol: '₽'},
]

export const CurrencySymbol = (key: string) => _.filter(currencies, {key: key})[0].symbol

// export const CurrencyRates = {
//     MXN: 1,
//     USD: 0.56,
//     EUR: 0.45,
// }

export const CurrencyFormat = (value: number | string, precision:number = 0) =>
    currency(value, {
        symbol: '',
        separator: ' ',
        precision: precision,
    }).format();